import 'regenerator-runtime/runtime';
import { call, put } from 'redux-saga/effects';

import { handleGenericError } from '../common';
import { makeRequest } from './horizon';
import { actions } from '../../reducers/iot/iot';

export default function* disconnectPort(action) {
  const { device, disconnectFrom } = action.payload;

  try {
    const path = `${disconnectFrom}/disconnect`;

    yield call(
      makeRequest,
      device.id,
      path,

      {
        method: 'post',
      },
      'disconnectPort'
    );
    yield put(actions.disconnectPortSuccess());
  } catch (e) {
    yield call(handleGenericError, action, e);
  }
}
